/**
 * `controllerchange` fires in every tab the new service worker claims
 * (clients.claim()), not only in the tab that asked for the update. Reload
 * just this tab when the user accepted the update toast here (`updateRequestedHere`
 * is set by the toast's Reload action, the only consent path) — otherwise one
 * tab's update would force-reload all the others.
 */
export function shouldReloadOnControllerChange(options: {
  hadControllerOnLoad: boolean
  isRefreshing: boolean
  isNavigatingAway: boolean
  updateRequestedHere: boolean
}) {
  const { hadControllerOnLoad, isRefreshing, isNavigatingAway, updateRequestedHere } = options

  return updateRequestedHere && hadControllerOnLoad && !isRefreshing && !isNavigatingAway
}
